import React from 'react';

export interface LeftNavSubmenuContextValue {
  /** True when sub-items are rendered inline in the expanded sidebar (not in the flyout panel). */
  isInline: boolean;
}

const defaultValue: LeftNavSubmenuContextValue = { isInline: false };

const LeftNavSubmenuContext =
  React.createContext<LeftNavSubmenuContextValue>(defaultValue);

export function LeftNavSubmenuProvider(
  props: React.PropsWithChildren<{ isInline: boolean }>
) {
  const { isInline, children } = props;
  const value = React.useMemo(() => ({ isInline }), [isInline]);
  return (
    <LeftNavSubmenuContext.Provider value={value}>
      {children}
    </LeftNavSubmenuContext.Provider>
  );
}

export function useLeftNavSubmenuContext(): LeftNavSubmenuContextValue {
  return React.useContext(LeftNavSubmenuContext) ?? defaultValue;
}
